export enum HappyReturnsBillingMode {
  RedoManaged = "REDO_MANAGED",
  HappyReturnsDirect = "HAPPY_RETURNS_DIRECT",
}
